import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutComponent } from './layout.component';
import { LayoutRoutingModule } from './layout-routing.module';
import { LayoutService } from './Services/layout.service';
import { NgZorroModule } from '../../shared/NG-Zorro-Antd/ng-zorro-antd.module';
import { HeaderComponent } from './Components/header/header.component';
import { SiderComponent } from './Components/sider/sider.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MenuComponent } from './Components/menu/menu.component';


@NgModule({
  declarations: [
    HeaderComponent,
    LayoutComponent,
    SiderComponent,
    MenuComponent,
  ],
  imports: [
    CommonModule,
    NgZorroModule,
    LayoutRoutingModule,
    FontAwesomeModule
  ],
  providers: [
    LayoutService,
  ],
  exports: [
    LayoutComponent
  ]
})

export class LayoutModule { }
